// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__jRXC2","LoaderWrapper":"Loader_LoaderWrapper__7xiMZ"};